import app from "js/legacy-app";

app.service('Helper', ['$resource', function($resource){
    return $resource('/api/helper/:id', {}, {});
}]);
